// extracted by mini-css-extract-plugin
export default {"modalsWrapper":"ModalsWrapper_modalsWrapper__npz0y"};